var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    className: "folder-key",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.folder-key .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#7BD500;}\n\t.folder-key .st1{opacity:0.3;}\n\t.folder-key .st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,3.5H4C3.2,3.5,2.5,4.2,2.5,5v13c0,0.8,0.7,1.5,1.5,1.5h16c0.8,0,1.5-0.7,1.5-1.5V7 c0-0.8-0.7-1.5-1.5-1.5h-8.8L9.9,3.5L9.9,3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,20H4c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h6.2l1.3,2H20c1.1,0,2,0.9,2,2v11C22,19.1,21.1,20,20,20z M4,4 C3.4,4,3,4.4,3,5v13c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V7c0-0.6-0.4-1-1-1h-9L9.7,4H4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.8,13.5l-2.7-2.6c0.6-1.1,0.3-2.4-0.7-3.1C10.4,7.1,9,7.2,8.1,8c-0.9,0.8-1,2.2-0.2,3.2 c0.8,1,2.1,1.3,3.2,0.7l2.2,2.1l-0.8,0.7c-0.2,0.2-0.3,0.4-0.2,0.7c0.1,0.2,0.3,0.4,0.5,0.5c0.3,0.1,0.5,0,0.7-0.2l0.8-0.7l0.3,0.3 l-0.9,0.8c-0.2,0.2-0.3,0.4-0.2,0.7c0.1,0.2,0.3,0.4,0.5,0.5c0.3,0.1,0.5,0,0.7-0.2l1.9-1.8L14.8,13.5z M9.1,10.5 C8.7,10.1,8.6,9.5,9,9c0,0,0,0,0,0c0.4-0.4,1.1-0.4,1.6,0c0.3,0.3,0.4,0.7,0.3,1c-0.1,0.4-0.4,0.7-0.8,0.8 C9.8,10.9,9.4,10.8,9.1,10.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderKey);
export default __webpack_public_path__ + "static/media/folder-key.a39244ed4817f8cdc02bc210ca0fd9fa.svg";
export { ForwardRef as ReactComponent };